import { render } from "./marketplaceActivation.vue?vue&type=template&id=169ab01d&scoped=true&ts=true"
import script from "./marketplaceActivation.vue?vue&type=script&lang=ts"
export * from "./marketplaceActivation.vue?vue&type=script&lang=ts"

import "./marketplaceActivation.vue?vue&type=style&index=0&id=169ab01d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169ab01d"]])

export default __exports__